export default "/images/404.svg?6ba46bec8b042aed83a1315f782ecbab";